import React from 'react';

import { useTeamForTeamClientId } from '../../models/useTeamForTeamClientId';
import { CompactTeamCard } from '../client/LoadableTeamsGrid';
import CenteredSpinner from '../CenteredSpinner';

export default function TeamClientTeamCard({ teamClientId, isAdmin, locStrings }) {
    // GET Team whose teamClientId is the teamClientId
    const [loading, team, teamId] = useTeamForTeamClientId(teamClientId);

    const onClickViewTeam = (teamId) => {
        const partUrl =  isAdmin ? `/admin/clients` : `/client/manage`;
        if (!teamId || !team) {
            return;
        }
        const { teamOwnerClientId } = team || {};
        window.location.href = `${partUrl}/${teamOwnerClientId}/teams/${teamId}`;
    }

    if (loading || !team || !teamId) {
        return <CenteredSpinner loading={loading} />;
    }

    return (
        <div>
            <CompactTeamCard
                team={team}
                clientId={teamClientId}
                isAdmin={isAdmin}
                locStrings={locStrings}
                onClick={() => onClickViewTeam(teamId)}
                clickText="View Team"
                titleText="View team"
            />
        </div>
    );
}
